
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.527 20.71H3.474A3.427 3.427 0 01.05 17.287V9.632a3.428 3.428 0 013.424-3.424h3.435l.015-.028 1.4-2.803a.58.58 0 01.52-.327h6.314a.58.58 0 01.518.327l1.401 2.803.014.028h3.436a3.427 3.427 0 013.423 3.424v7.655a3.427 3.427 0 01-3.423 3.423zM3.669 7.473c-1.24 0-2.21.97-2.21 2.21v7.48c0 1.24.97 2.211 2.21 2.211h16.663c1.24 0 2.21-.971 2.21-2.211v-7.48c0-1.24-.97-2.21-2.21-2.21h-3.703a.566.566 0 01-.504-.31l-1.38-2.748-.013-.028H9.27l-.015.028-1.379 2.748a.566.566 0 01-.504.31H3.669z"}}),_c('path',{attrs:{"d":"M12 17.299a4.376 4.376 0 01-4.371-4.372c0-2.41 1.96-4.371 4.371-4.371 2.41 0 4.372 1.96 4.372 4.371A4.377 4.377 0 0112 17.299zm0-7.504a3.136 3.136 0 00-3.132 3.132A3.136 3.136 0 0012 16.06a3.137 3.137 0 003.133-3.133A3.136 3.136 0 0012 9.795z"}})])
          )
        }
      }
    